import { render, staticRenderFns } from "./HistoryDialog.vue?vue&type=template&id=246114ff&scoped=true"
import script from "./HistoryDialog.vue?vue&type=script&lang=js"
export * from "./HistoryDialog.vue?vue&type=script&lang=js"
import style0 from "./HistoryDialog.vue?vue&type=style&index=0&id=246114ff&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246114ff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('246114ff')) {
      api.createRecord('246114ff', component.options)
    } else {
      api.reload('246114ff', component.options)
    }
    module.hot.accept("./HistoryDialog.vue?vue&type=template&id=246114ff&scoped=true", function () {
      api.rerender('246114ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/platformManage/staff/components/HistoryDialog.vue"
export default component.exports